import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

type Props = {
    modelWorkingTitle: string;
    path: any;
    alt: string;
    title: string;
    width: number;
    height: number;
    url: any;
    children: any;
};

const ModelWorking: React.FC<Props> = ({ modelWorkingTitle, children, path, alt, title, width, height, url }) => {
    return (
        <div
            className="card p-5 md:p-5 lg:p-30 bg-white dark:bg-black rounded-10 border"
            data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="300"
        >
            <div className="card-body model-description text-textcolor dark:text-light">
                <Image src={`${path}`} width={width} height={height} alt={alt} title={title} className="img-fluid mb-5" loading="lazy" />
                <h3 className="card-title fs-lg fw-700 mb-2.5">{modelWorkingTitle}</h3>
                {children}
                <Link href={`${url}`} className="btn btn-outline-primary mt-2.5">
                    Explore
                </Link>
            </div>
        </div>
    );
};

export default ModelWorking;
